export function extractAuthorization() {
	if (typeof window === 'undefined') {
		return '';
	}

	const params = new URLSearchParams(window.location.search);

	// Prefer a workforce (Bearer) token when present. Workforce task links open with
	// `?workforceAuth=<token>` (see services/workforce) and the API's uploadAuth
	// middleware authenticates uploads via this Bearer token. This mirrors the
	// `workforceAuth || basicAuth` precedence used by the task page itself.
	const workforceAuth = params.get('workforceAuth');
	if (workforceAuth) {
		return `Bearer ${workforceAuth}`;
	}

	if (!params.has('auth')) {
		const storedAuth = sessionStorage.getItem('accessAuthToken');
		if (storedAuth) return `Basic ${storedAuth}`;
		return '';
	}

	return `Basic ${params.get('auth')}`;
}

export function extractAuthParams() {

	if (typeof window === 'undefined') {
		return '';
	}

	const params = new URLSearchParams(window.location.search);
	const deviceId = params.get('deviceId');
	const deviceToken = params.get('deviceToken');

	if (deviceId && deviceToken) return `deviceId=${deviceId}&deviceToken=${deviceToken}`;
	return '';
}
